/**
 * Mapiranje statusa obaveze na faze životnog ciklusa (PROPOSAL, ALIGNMENT, PLANNING).
 */
import { normalizePlatformRoles } from '@/shared/auth/obligationAuth';

/** Faze životnog ciklusa obaveze. @type {{ PROPOSAL: string, ALIGNMENT: string, PLANNING: string }} */
export const OBLIGATION_PHASES = {
  PROPOSAL: 'PROPOSAL',
  ALIGNMENT: 'ALIGNMENT',
  PLANNING: 'PLANNING',
};

const STATUS_TO_PHASE = {
  CREATED: OBLIGATION_PHASES.PROPOSAL,
  UNDER_REVIEW: OBLIGATION_PHASES.ALIGNMENT,
  REJECTED: OBLIGATION_PHASES.ALIGNMENT,
  ACCEPTED: OBLIGATION_PHASES.PLANNING,
  PARTIALLY_ACCEPTED: OBLIGATION_PHASES.PLANNING,
  REJECTED_AFTER_REVIEW: OBLIGATION_PHASES.ALIGNMENT,
  IN_IMPLEMENTATION: OBLIGATION_PHASES.PLANNING,
};

/**
 * Određuje fazu obaveze na osnovu BE statusa.
 * @param {string|null|undefined} status - Status obaveze (npr. `UNDER_REVIEW`, `ACCEPTED`).
 * @returns {string} Vrednost iz `OBLIGATION_PHASES`.
 */
export const getObligationPhaseFromStatus = (status) => {
  if (!status) return OBLIGATION_PHASES.PROPOSAL;
  return STATUS_TO_PHASE[status] || OBLIGATION_PHASES.PROPOSAL;
};

/**
 * Normalizuje JWT uloge korisnika u `Set` za brze membership provere.
 * @param {object|null|undefined} user - Autentifikovani korisnik.
 * @returns {Set<string>} Skup normalizovanih uloga.
 */
export const getRoleSet = (user) => new Set(normalizePlatformRoles(user));
